export const DEFAULT_MESSAGE =
  'Sorry, something went wrong. Please come back in a few minutes and try again.';
